import { InformationPopover, TextArea } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import { formatErrors } from '@spa/components/FormFields/helpers'
import { Controller, type Control, type FieldErrors } from 'react-hook-form'

type Props = {
  control: Control
  errors: FieldErrors
  isShiftLocked: boolean
}
export const ShiftNote = ({ control, errors, isShiftLocked }: Props) => {
  const { t } = usePlanningFormTranslation()
  return (
    <Controller
      name='note'
      control={control}
      render={({ field: { onChange, value } }) => (
        <TextArea
          errorMessage={formatErrors({
            inputName: 'note',
            errors
          })}
          label={t('component.fieldTextArea.title')}
          labelRightSection={
            <InformationPopover
              content={t('component.fieldTextArea.infoTooltip')}
            />
          }
          name='user_contract'
          placeholder={t('component.fieldTextArea.title')}
          disabled={isShiftLocked}
          value={value}
          onChange={onChange}
          className='mb-2'
        />
      )}
    />
  )
}
